module.exports = __webpack_public_path__ + "img/star_border_24px.300d516c.svg";